import {
  type APIResponse,
  type MatterTeam,
  type MatterTeamConnection,
} from "@/lib/types";
import { authenticatedFastApiAxiosInstance } from "../../http";
import { baseFastApiMatterRoute } from "./matter";

export const createMatterTeam = (data: Partial<MatterTeam>) => {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<MatterTeam>>(`${baseFastApiMatterRoute}/teams`, data)
    .then((res) => res.data);
};

export const updateMatterTeam = (
  data: Pick<MatterTeam, "id" | "dateModified"> & Partial<MatterTeam>,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<MatterTeam>>(`${baseFastApiMatterRoute}/teams`, data)
    .then((res) => res.data);
};

export const deleteMatterTeam = (data: { id: string }) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<MatterTeam>>(`${baseFastApiMatterRoute}/teams/${id}`)
    .then((res) => res.data);
};

export const createMatterTeamConnection = (data: {
  matterId: string;
  teamId: string;
}) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterTeam>
    >(`${baseFastApiMatterRoute}/teams/connections`, data)
    .then((res) => res.data);
};

export const updateMatterTeamConnections = (data: {
  matterId: string;
  teamIds: string[];
}) =>
  authenticatedFastApiAxiosInstance
    .put<
      APIResponse<{
        matterId: string;
        createdIds: string[];
        deletedIds: string[];
      }>
    >(`${baseFastApiMatterRoute}/teams/connections/bulk`, data)
    .then((res) => res.data);

export const updateMatterTeamConnection = (
  data: Pick<
    MatterTeamConnection,
    "matterId" | "id" | "dateTimeEnd" | "dateTimeStart" | "dateModified"
  >,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterTeam>
    >(`${baseFastApiMatterRoute}/teams/connections`, data)
    .then((res) => res.data);
};

export const deleteMatterTeamConnection = (data: { id: string }) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterTeam>
    >(`${baseFastApiMatterRoute}/teams/connections/${id}`)
    .then((res) => res.data);
};
